// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"26":"33697742","307":"979398e9","383":"33697742","725":"58313c4f"}[chunkId] + ".chunk.css";
};